"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserInfo = exports.isomorphism = exports.currentPcLanguage = exports.country2languages = exports.PRICE_SYMBOL_TWC = exports.PRICE_SYMBOL_PK = exports.PRICE_SYMBOL_TH = exports.PRICE_SYMBOL_ID = exports.PRICE_SYMBOL_AU = exports.PRICE_SYMBOL_MY = exports.PRICE_SYMBOL_SG = exports.errorInfo = void 0;
var ssrcontext_1 = require("../../ssrcontext");
var debug_1 = require("utils/debug");
var cachedGetResult_1 = require("../cachedGetResult");
var website_1 = require("../website");
var WebSiteStore_1 = require("mobile/models/WebSiteStore");
var customer_public_1 = require("services/nadesico/customer_public");
var cookie_1 = require("../cookie");
var WebSiteStore = WebSiteStore_1.getStore();
var ipAddressRegex = /^(?:\d{1,3}\.){3}\d{1,3}$/;
exports.errorInfo = "Opps, something is wrong. Please try again later or contact our customer service officer to assist you.";
exports.PRICE_SYMBOL_SG = "S$";
exports.PRICE_SYMBOL_MY = "RM";
exports.PRICE_SYMBOL_AU = "AU$";
exports.PRICE_SYMBOL_ID = "Rp";
exports.PRICE_SYMBOL_TH = "THB";
exports.PRICE_SYMBOL_PK = "₨.";
exports.PRICE_SYMBOL_TWC = "NT$";
exports.country2languages = {
    SG: ["en", "zh"],
    MY: ["en", "ms", "zh"],
    ID: ["en", "id"],
    TH: ["en", "th"],
    PK: ["en"],
    TWC: ["zhtw", "en"],
    LITB: ["en"]
};
var lanNode = typeof document === "object"
    ? document.getElementById("LanguageCode")
    : null;
var lang = "";
if (lanNode !== null && lanNode.value.length >= 2) {
    lang = lanNode.value;
}
var langs = {
    EN: "en",
    TH: "th",
    MY: "ms",
    ZNCH: "zh",
    ID: "id",
    ZHTW: "ZhTw"
};
exports.currentPcLanguage = langs[lang.toUpperCase()] || "";
var handleTWCountryCode = function (code) {
    return (code || "").replace("TW", "TWC");
};
var meta = {
    country: "",
    lang: "",
    currency: "",
    priceGraph: ""
};
var userInfo = {
    customerId: "0"
};
var SiteCode;
(function (SiteCode) {
    SiteCode[SiteCode["Ezbuy"] = 1] = "Ezbuy";
    SiteCode[SiteCode["MCEzbuy"] = 2] = "MCEzbuy";
    SiteCode[SiteCode["LITB"] = 3] = "LITB";
})(SiteCode || (SiteCode = {}));
var serverSideRender = ssrcontext_1.runInServer();
function isomorphism(_target, propertyKey, descriptor) {
    if (serverSideRender) {
        descriptor.get = function () {
            return ssrcontext_1.getSnapshoot()[propertyKey];
        };
    }
}
exports.isomorphism = isomorphism;
exports.getUserInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
    var nextUserInfo;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (Constant.userInfo.customerId && Constant.userInfo.customerId !== "0") {
                    return [2, Constant.userInfo];
                }
                return [4, customer_public_1.GetCustomerInfo({})];
            case 1:
                nextUserInfo = _a.sent();
                return [2, {
                        customerId: (nextUserInfo && nextUserInfo.id) || "0"
                    }];
        }
    });
}); };
var Constant = (function () {
    function Constant() {
    }
    Object.defineProperty(Constant, "siteCode", {
        get: function () {
            return SiteCode.LITB;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "countryCode", {
        get: function () {
            var hostname = (ssrcontext_1.runInServer()
                ? { hostname: ssrcontext_1.getSnapshootByKey("hostname") }
                : window.location).hostname;
            var domains = hostname.split(/\./);
            if (debug_1.isLTDomain()) {
                if (debug_1.isMiniDomain()) {
                    return "LITBMINI";
                }
                return "LITB";
            }
            if (debug_1.isLitbOukuDomain()) {
                return "LITBOUKU";
            }
            if (debug_1.isUAT()) {
                var result = sessionStorage.getItem("debug_country");
                if (result !== null) {
                    return result.toLocaleUpperCase();
                }
                if (hostname !== "localhost" && !ipAddressRegex.test(hostname) && domains.length > 2) {
                    return handleTWCountryCode(domains.length === 3
                        ? domains[0].toUpperCase().replace(/[0-9]/g, "")
                        : domains[1].toUpperCase());
                }
            }
            else if (hostname.indexOf("ezbuy") > -1) {
            }
            return "SG";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "regionCode", {
        get: function () {
            return "Region" + this.countryCode;
        },
        enumerable: false,
        configurable: true
    });
    Constant.getCountryValue = function (sg, my, th, id, pk, twc, mc) {
        switch (Constant.countryCode) {
            case "SG":
                return sg;
            case "MY":
                return my;
            case "TH":
                return th;
            case "ID":
                return id;
            case "PK":
                return pk;
            case "TWC":
                return twc;
            case "MC":
                return mc;
        }
        return sg;
    };
    Object.defineProperty(Constant, "priceSymbol", {
        get: function () {
            return Constant.getCountryValue(exports.PRICE_SYMBOL_SG, exports.PRICE_SYMBOL_MY, exports.PRICE_SYMBOL_TH, exports.PRICE_SYMBOL_ID, exports.PRICE_SYMBOL_PK, exports.PRICE_SYMBOL_TWC, exports.PRICE_SYMBOL_AU);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "languageCode", {
        get: function () {
            if (debug_1.isLTDomain() || debug_1.isLitbOukuDomain()) {
                return "en";
            }
            if (debug_1.isLocalDevelop()) {
                var result = sessionStorage.getItem("debug_country");
                if (result !== null) {
                    if (result.toLocaleUpperCase() === "THE") {
                        return "th";
                    }
                }
            }
            var _a = window.navigator, _b = _a.language, language = _b === void 0 ? "" : _b, _c = _a.languages, languages = _c === void 0 ? [] : _c;
            var cCountryLanguages = exports.country2languages[Constant.countryCode] || exports.country2languages["SG"];
            var lang = languages && languages.length > 0 ? languages[0] : language;
            var languageArr = lang.split("-");
            if (exports.currentPcLanguage) {
                return exports.currentPcLanguage;
            }
            return lang === "" || languageArr.length > 2
                ? cCountryLanguages[0]
                : cCountryLanguages.includes(languageArr[0])
                    ? languageArr[0]
                    : cCountryLanguages[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "platform", {
        get: function () {
            return website_1.isPC() ? "pc" : "mobile";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "currencyCode", {
        get: function () {
            return Constant.getCountryValue("SGD", "MYR", "THB", "IDR", "PKR", "TWD", "MC");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "sid", {
        get: function () {
            return cookie_1.getItem("sid") || "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "sessionkey", {
        get: function () {
            return cookie_1.getItem("sessionkey") || "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "regionFullName", {
        get: function () {
            return Constant.getCountryValue("Singapore", "Malaysia", "Thailand", "Indonesia", "Pakistan", "Taiwan", "Australia");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "websiteDomain", {
        get: function () {
            return Constant.getCountryValue("https://ezbuy.sg", "https://ezbuy.my", "https://ezbuy.co.th", "https://ezbuy.co.id", "https://pk.ezbuy.com", "https://tw.ezbuy.com", "https://www.ezbuy.com/");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "pcUatUrlMap", {
        get: function () {
            return {
                SG: "http://sg.65emall.net",
                MY: "http://my.65emall.net",
                TH: "http://th.65emall.net",
                ID: "http://id.65emall.net",
                PK: "http://pk.65emall.net",
                TWC: "http://tw.65emall.net",
                MC: "https://web.ezbuy.dev"
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "pcOnlineUrlMap", {
        get: function () {
            return {
                SG: "https://ezbuy.sg",
                MY: "https://ezbuy.my",
                TH: "https://ezbuy.co.th",
                ID: "https://ezbuy.co.id",
                PK: "https://pk.ezbuy.com",
                TWC: "https://tw.ezbuy.com",
                MC: "https://country.ezbuy.com"
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "mobileUATUrlMap", {
        get: function () {
            var _a;
            return _a = {
                    SG: "http://m.sg.65emall.net",
                    MY: "http://m.my.65emall.net",
                    TH: "http://m.th.65emall.net",
                    ID: "http://m.id.65emall.net",
                    PK: "http://m.pk.65emall.net",
                    TWC: "http://m.tw.65emall.net",
                    MC: "https://m.ezbuy.dev"
                },
                _a[this.country] = WebSiteStore.getParams("mobileUrl"),
                _a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "mobileOnlineUrlMap", {
        get: function () {
            var _a;
            return _a = {
                    SG: "https://m.ezbuy.sg",
                    MY: "https://m.ezbuy.my",
                    TH: "https://m.ezbuy.co.th",
                    ID: "https://m.ezbuy.co.id",
                    PK: "https://m-pk.ezbuy.com",
                    TWC: "https://m-tw.ezbuy.com",
                    MC: "https://m.ezbuy.com"
                },
                _a[this.country] = WebSiteStore.getParams("mobileUrl"),
                _a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "country", {
        get: function () {
            return meta.country;
        },
        set: function (country) {
            try {
                country && (meta.country = country.toUpperCase());
            }
            catch (e) {
                console.error(e);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "language", {
        get: function () {
            return meta.lang || this.languageCode;
        },
        set: function (language) {
            try {
                language && (meta.lang = language.toLowerCase());
            }
            catch (e) {
                console.error(e);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "currency", {
        get: function () {
            return meta.currency || this.currencyCode;
        },
        set: function (currency) {
            try {
                currency && (meta.currency = currency.toUpperCase());
            }
            catch (e) {
                console.error(e);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "priceGraph", {
        get: function () {
            return meta.priceGraph;
        },
        set: function (graph) {
            try {
                meta.priceGraph = graph;
            }
            catch (e) {
                console.error(e);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "userInfo", {
        get: function () {
            return userInfo;
        },
        set: function (user) {
            userInfo = user;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Constant, "multiLanImgKey", {
        get: function () {
            return this.language.toLowerCase() + "_" + this.currency.toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        isomorphism,
        cachedGetResult_1.default
    ], Constant, "siteCode", null);
    __decorate([
        isomorphism,
        cachedGetResult_1.default
    ], Constant, "countryCode", null);
    __decorate([
        cachedGetResult_1.default
    ], Constant, "priceSymbol", null);
    __decorate([
        isomorphism,
        cachedGetResult_1.default
    ], Constant, "languageCode", null);
    __decorate([
        isomorphism,
        cachedGetResult_1.default
    ], Constant, "platform", null);
    __decorate([
        isomorphism,
        cachedGetResult_1.default
    ], Constant, "currencyCode", null);
    __decorate([
        isomorphism,
        cachedGetResult_1.default
    ], Constant, "sid", null);
    __decorate([
        isomorphism,
        cachedGetResult_1.default
    ], Constant, "sessionkey", null);
    __decorate([
        cachedGetResult_1.default
    ], Constant, "regionFullName", null);
    __decorate([
        cachedGetResult_1.default
    ], Constant, "websiteDomain", null);
    __decorate([
        cachedGetResult_1.default
    ], Constant, "pcUatUrlMap", null);
    __decorate([
        cachedGetResult_1.default
    ], Constant, "pcOnlineUrlMap", null);
    __decorate([
        cachedGetResult_1.default
    ], Constant, "mobileUATUrlMap", null);
    __decorate([
        cachedGetResult_1.default
    ], Constant, "mobileOnlineUrlMap", null);
    return Constant;
}());
exports.default = Constant;
